// TODO: Add an "Are you sure?" alert on skip
// TODO: Need a way to alert when the trial credits run out.
import { Link } from "react-router-dom";
import React, { useState, useMemo, useEffect } from "react";
import "./index.scss";
import queryString from "query-string";
import loadingIcon from "../../Assets/loading.gif";
import Player from "../../Components/PlayerNew";
import axios from "axios";
import mixpanel from "mixpanel-browser";

const Onboarding = ({ location: { search } }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [audioUrl, setAudioUrl] = useState("");
  const [articleTitle, setArticleTitle] = useState("");
  const [isFullPlayer, updateIsFullPlayer] = useState(false);
  const articleUrl = queryString.parse(search).article_url;
  const onLoadedMetadata = useMemo(() => () => setIsLoading(false), []);

  const currentArticle = useMemo(
    () => ({
      id: articleUrl,
      article_url: articleUrl,
      title: articleTitle,
      audio_url: audioUrl,
    }),
    [articleUrl, audioUrl, articleTitle]
  );

  useEffect(() => {
    mixpanel.track("Open Sample Audio Page (Onboarding)");
  }, []);
  useEffect(() => {
    if (articleUrl) {
      axios
        .get(
          `${
            process.env.REACT_APP_BACKEND_URL
          }/api/demo/sample_audio?article_url=${encodeURIComponent(articleUrl)}`
        )
        .then((res) => {
          setArticleTitle(res.data.title);
          setAudioUrl(res.data.audio_url);
        });
    }
  }, [articleUrl]);

  return (
    <div className="onboarding">
      {isLoading && (
        <div className="center">
          <h1 className="headline" style={{ paddingBottom: 10 }}>
            Synthesizing Audio...{" "}
          </h1>
          <h2 className="subheadline" style={{ margin: "30px" }}>
            {articleUrl}
          </h2>
          <div>
            <img src={loadingIcon} 
            style={{height: '50px'}}alt="loading..."></img>
          </div>
        </div>
      )}
      <div
        className="center"
        style={{
          visibility: isLoading ? "hidden" : "visible",
        }}
      >
        <h1 className="headline" style={{ paddingBottom: 10 }}>
          Sample Audio{" "}
        </h1>
        <h2 className="subheadline">
          Start a free trial to listen to the full audio
        </h2>
        <div
          style={{
            height: 86,
            width: "100vw",
            maxWidth: 1200,
            margin: "30px auto",
          }}
        >
          <Player
            {...{
              isFullPlayer,
              updateIsFullPlayer,
              onLoadedMetadata,
              currentArticle,
              listeningWhere: "/onboarding",
              autoPlay: false,
              fullPlayerLeaveSpace: 0,
            }}
          />
        </div>
        <div className="cta-div">
          <Link
            to="/onboarding/trial"
            className="cta-button"
            onClick={(e) => {
              mixpanel.track("Click Start Free Trial (Onboarding)", {
                placement: "Sample Audio",
              });
            }}
          >
            <div>Start 3-Day Free Trial</div>
            <div
              style={{
                fontSize: "medium",
                fontWeight: "normal",
              }}
            >
              $4.99/mo after. Cancel anytime.
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
